<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-12-04 10:53:20
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-03-17 15:26:59
 * @FilePath: \bigdatamangeer\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="particles-js" class="main">
    <div class="bigMapdata" v-show="isSHowmap">
      <div style="width:100%;height:100%;" id="mainmapBox"></div>
      <div class="maincloseBox">
        <img src="./assets/close.png" alt @click="colorMpa" />
      </div>
    </div>
    <div class="main_con">
      <div class="main_top">
        <div class="main_top_left">
          <div class="main_top_left_top main_top_left_bottom22">
            <img src="./images/main_top_left.png" />
            <div class="main_top_left_top_title">克拉玛依各区已完成任务（亩）</div>
            <div id="baseId" class="main_top_left_top_con"></div>
          </div>
          <!-- <div class="main_top_left_top main_top_left_bottom">
            <img src="./images/main_top_left.png" />
            <div class="main_top_left_top_title">外业人员活动里程数</div>
            <div id="waiye" class="main_top_left_top_con"></div>
          </div>-->
        </div>
        <div class="main_top_middle">
          <div class="main_top_middle_top_title">
            <img class="title_bg" src="./images/title_bg.png" />
            外业GIS数据可视化平台
            <a
              class="title_web"
              href="http://114.117.178.89/#/"
              target="blank"
            >管理系统</a>
            <a class="title_admin" href="http://114.117.178.89/#/" target="blank">web网页</a>
          </div>
          <div class="textbox">
            <div class="my21box">
              <div class="main_top_middle_num_title">已验标田块</div>
              <div class="main_top_middle_num">
                <!--                    <div class="main_top_middle_num_list">-->
                <!--                        <img src="./images/center_num.png">-->
                <!--                        <p class="main_top_middle_num_list6">0</p>-->
                <!--                    </div>-->
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list5">{{mjdata[0]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list4">{{mjdata[1]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list3">{{mjdata[2]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list2">{{mjdata[3]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list1">{{mjdata[4]}}</p>
                </div>
              </div>
            </div>
            <div class="my21box">
              <div class="main_top_middle_num_title">已验标面积</div>
              <div class="main_top_middle_num">
                <!--                    <div class="main_top_middle_num_list">-->
                <!--                        <img src="./images/center_num.png">-->
                <!--                        <p class="main_top_middle_num_list6">0</p>-->
                <!--                    </div>-->
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list5">{{tbtk[0]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list4">{{tbtk[1]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list3">{{tbtk[2]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list2">{{tbtk[3]}}</p>
                </div>
                <div class="main_top_middle_num_list">
                  <img src="./images/center_num.png" />
                  <p class="main_top_middle_num_list1">{{tbtk[4]}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="main_top_middle_bottom">
            <!-- <div class="main_top_middle_bottom_echarts">
              <img src="./images/main_top_bottom.png" />
              <div class="main_top_echarts_con">
                <div class="main_top_echarts_con_title">作物投保数量（面积/亩）</div>
                <div id="threeTasksId" class="main_top_echarts_pie"></div>
              </div>
            </div>-->
            <!-- <div class="main_top_middle_bottom_echarts main_top_middle_bottom_echarts_right">
              <img src="./images/main_top_bottom.png" />
              <div class="main_top_echarts_con">
                <div class="main_top_echarts_con_title">各区投保户数</div>
                <div id="publicityId" class="main_top_echarts_pie"></div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="main_top_left main_top_right">
          <div class="main_top_left_top">
            <img src="./images/main_top_left.png" />
            <div class="main_top_left_top_title">外业人员活动里程（公里）</div>
            <div class="main_top_left_top_con">
              <!-- <div id="baseId3" class="main_top_left_top_con"></div> -->
              <div id="waiye2" class="main_top_left_top_con"></div>
              <!-- <div class="itemBox" v-for="item in 9"></div> -->
            </div>
          </div>
          <!-- <div class="main_top_left_top main_top_left_bottom">
            <img src="./images/main_top_left.png" />
            <div class="main_top_left_top_title">目标任务区域占比</div>
            <div id="questionId" class="main_top_left_top_con"></div>
          </div>-->
        </div>
      </div>

      <div class="main_bottom">
        <div class="main_bottom_bottom">
          <div class="main_bottom_b_left">
            <img src="./images/main_bottom_bottom.png" />
            <div class="main_bottom_b_title">作物投保数量（亩）</div>
            <div id="waiye" class="main_bottom_b_con"></div>
          </div>
          <div class="main_bottom_b_middle1">
            <img src="./images/main_bootm_middle.png" />
            <div class="main_bottom_b_title">外业人员分布</div>
            <div class="mymapBox main_bottom_b_con main_bottom_b_con2" id="mymap"></div>
            <!-- <div id="contentId" class="main_bottom_b_con main_bottom_b_con2"></div> -->
          </div>
          <div class="main_bottom_b_middle2">
            <img src="./images/main_bootm_middle.png" />
            <div class="main_bottom_b_title">田块分布</div>
            <!-- <div class="main_bottom_b_con main_bottom_b_con2" id="showmap"></div> -->
            <div id="publicNumId" class="mymapBox main_bottom_b_con main_bottom_b_con2"></div>
          </div>
          <div class="main_bottom_b_right">
            <img src="./images/main_bottom_bottom.png" />
            <div class="main_bottom_b_title">目标任务/在线状态</div>
            <div class="main_bottom_b_con33 myhashbox">
              <div id="baseId3" class="main_top_left_top_con55"></div>
              
            </div>
           
          </div>
        </div>

        <div class="main_bottom_top">
          <div class="main_bottom_top_list">
            <img src="./images/main_bottopm_top1.png" />
            <div class="main_bottom_t_l_title">实时验标</div>
            <div class="main_bottom_t_l_con" style="top: -35px">
              <div class="main_bottom_t_l_main">
                <ul>
                  <li v-for="item in tblist">
                    <div class="main_bottom_t_l_main_list">
                      <div
                        class="main_bottom_t_list_title main_bottom_t_list_title1"
                      >王XX—已完成疏勒县塔孜洪乡玉米 {{getRoundNum()}} 亩验标</div>
                      <div
                        class="main_bottom_t_list_time main_bottom_t_list_time1"
                      >{{getnewTime(item.create_time)}}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="main_bottom_top_list" v-show="false">
            <img src="./images/main_bottopm_top2.png" />
            <div class="main_bottom_t_l_title">田块修改信息占比</div>
            <div id="departmentId" class="main_bottom_t_l_chart"></div>
          </div>-->
          <!-- <div class="main_bottom_top_list">
            <img src="./images/main_bottopm_top1.png" />
            <div class="main_bottom_t_l_title">外业人员任务</div>
            <div class="main_bottom_t_l_con" style="top: -15px">
              <div class="main_bottom_t_l_main2">
                <ul>
                  <li>
                    <div class="main_bottom_t_l_main_list">
                      <div
                        class="main_bottom_t_list_title main_bottom_polity_title1"
                      >王XX 已完成160玉米亩标定</div>
                      <div class="main_bottom_t_list_time main_bottom_polity_time1">2023/05/20</div>
                    </div>
                  </li>
                  <li>
                    <div class="main_bottom_t_l_main_list">
                      <div
                        class="main_bottom_t_list_title main_bottom_polity_title2"
                      >张XX 已完成160土豆亩标定</div>
                      <div class="main_bottom_t_list_time main_bottom_polity_time1">2023/05/20</div>
                    </div>
                  </li>
                  <li>
                    <div class="main_bottom_t_l_main_list">
                      <div
                        class="main_bottom_t_list_title main_bottom_polity_title3"
                      >张XX 已完成160棉花亩标定</div>
                      <div class="main_bottom_t_list_time main_bottom_polity_time1">2023/05/20</div>
                    </div>
                  </li>
                  <li>
                    <div class="main_bottom_t_l_main_list">
                      <div
                        class="main_bottom_t_list_title main_bottom_polity_title4"
                      >张XX 已完成160小麦亩标定</div>
                      <div class="main_bottom_t_list_time main_bottom_polity_time1">2023/05/20</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>-->
        </div>
        <div class="main_middle">
          <div class="main_middle_list">
            <img src="./images/main_middle.png" />
            <div class="main_list_title main_list_title1">新增田块（块）</div>
            <span class="main_list_title_num main_list_title_num1">0</span>
          </div>
          <div class="main_middle_list">
            <img src="./images/main_middle.png" />
            <div class="main_list_title main_list_title2">修改田块（块）</div>
            <span class="main_list_title_num main_list_title_num2">0</span>
          </div>
          <div class="main_middle_list">
            <img src="./images/main_middle.png" />
            <div class="main_list_title main_list_title3">上传照片（户数）</div>
            <span class="main_list_title_num main_list_title_num3">{{getphotoNum}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/index.css"; //@代表的是你的项目根路径
import "@/assets/css/reset.css";
// import $ from "jquery";
import moment from "moment";
import mypng from "@/assets/p.png";
import "@/assets/js/dataScoll.js";
import "@/assets/js/digitalScroll.js";
import "@/assets/js/jcarousellite.js";
import "@/assets/js/particles.js";

import { MapCreate, legendColor } from "./map/mapImport";
import { MapCreate2 } from "./map/mapImport2";
import * as L from "leaflet";
// import * as L from "leaflet";
import normal from "./map/ditu.js";
import "./map/line.js";
// import normal from "./map/ditu.js";
export default {
  data() {
    return {
      bigMapBox: null,
      getphotoNum: 0,
      tblist: [],
      mjdata: [0, 0, 0, 0, 0],
      tbtk: [0, 0, 0, 0, 0],
      map: null,
      map2: null,
      map3: null,
      isSHowmap: false,
      userList: [
        {
          name: "用户A",
          state: 1
        },
        {
          name: "用户B",
          state: 0
        },
        {
          name: "用户C",
          state: 1
        },
        {
          name: "用户D",
          state: 0
        },
        {
          name: "用户E",
          state: 1
        },
        {
          name: "用户F",
          state: 1
        }
      ]
    };
  },
  mounted() {
    this.getmjdata();
    this.gettblist();
    this.getphotonum();
    let t = this;
    $(function() {
      // let t = this;
      function apiFn() {
        this.hostname = "";
      }
      apiFn.prototype = {
        Init: function() {
          this.findCount();
          this.otherDataFn();
          this.baseInfo();
          this.baseInfo2();
          this.baseInfo3();
          // this.questionFn();
          this.publicityFn();
          this.threeTasksFn();
          // this.departmentFn();
          this.guideFn();
          this.policyFn();
          // this.coverageFn();
          // this.coverageFn2();
          this.yearsNumFn();
          this.contentFn();
          this.publicNumFn();

          setInterval(function() {
            numInit();
          }, 6000);
        },
        findCount: function() {},
        // 其他数据展示
        otherDataFn: function() {
          $(".daysData")
            .addClass("counter-value")
            .text("304");
          $(".weekData")
            .addClass("counter-value")
            .text("2044");
          $(".monthData")
            .addClass("counter-value")
            .text("909");
          $(".someThing")
            .addClass("counter-value")
            .text("980");
          $(".policyData")
            .addClass("counter-value")
            .text("200");
        },
        // 基础信息
        baseInfo: function() {
          console.log(111);
          var baseChart = echarts.init(document.getElementById("baseId"));
          var charts = [
            { name: "农业开发区", num: 2000 },
            { name: "小拐乡", num: 3000 },
            { name: "胜利路街道", num: 400 },
            { name: "金龙镇街道", num: 500 },
            { name: "五五新镇街道", num: 300 },
            { name: "金龙镇街道", num: 500 },
            { name: "金龙镇街道", num: 500 },
            { name: "乌尔禾乡", num: 1500 },
            { name: "西宁路街道", num: 1520 }
          ];
          let lablelist = [];
          let valueList = [];
          charts.map(item => {
            lablelist.push(item.name);
            valueList.push(item.num);
          });
          var color = [
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249"
          ];

          let lineY = [];
          for (var i = 0; i < charts.length; i++) {
            var x = i;
            if (x > color.length - 1) {
              x = color.length - 1;
            }
            var data = {
              name: charts[i].name,
              color: color[x] + ")",
              value: charts[i].num,
              itemStyle: {
                normal: {
                  show: true,
                  color: new echarts.graphic.LinearGradient(
                    0,
                    0,
                    1,
                    0,
                    [
                      {
                        offset: 0,
                        color: color[x] + ", 0.3)"
                      },
                      {
                        offset: 1,
                        color: color[x] + ", 1)"
                      }
                    ],
                    false
                  ),
                  barBorderRadius: 10
                },
                emphasis: {
                  shadowBlur: 15,
                  shadowColor: "rgba(0, 0, 0, 0.1)"
                }
              }
            };
            lineY.push(data);
          }
          var option = {
            color: [
              "#38EB70",
              "#2E8CFF",
              "#0EFCFF",
              "#858FF8",
              "#FD9133",
              "#F7E270"
            ],
            grid: {
              left: "3%",
              right: "5%",
              bottom: "3%",
              containLabel: true
            },
            dataZoom: [
              {
                type: "slider", //slider表示有滑动块的，
                show: true,
                width: 8,
                fillerColor: "rgb(16, 171, 198)",
                yAxisIndex: [0], //表示x轴折叠
                start: 1, //数据窗口范围的起始百分比,表示1%
                end: 35 //数据窗口范围的结束百分比,表示35%坐标
              },
              {
                type: "inside", //
                yAxisIndex: [0], //表示y轴折叠
                start: 1,
                end: 35
              }
            ],
            xAxis: [
              {
                type: "value",
                axisLine: {
                  lineStyle: {
                    color: "#fff"
                  }
                }
              }
            ],
            yAxis: {
              type: "category",
              data: lablelist,
              axisLine: {
                lineStyle: {
                  color: "#fff"
                }
              },
              axisLabel: {
                fontSize: 14,
                fontWeight: 700
              }
            },
            series: [
              {
                data: valueList,
                type: "bar",
                barWidth: 10
              }
            ],
            animationEasing: "cubicOut"
          };
          baseChart.on("click", function(params) {
            alert(`切换详细${params.name}信息`);
          });
          baseChart.setOption(option);
          setInterval(function() {
            baseChart.clear();
            baseChart.setOption(option);
          }, 40000);
        },
        baseInfo3: function() {
          // console.log(111);
          var baseChart = echarts.init(document.getElementById("baseId3"));
          var charts = [
            { name: "农业开发区", num: 2000 },
            { name: "小拐乡", num: 3000 },
            { name: "胜利路街道", num: 400 },
            { name: "金龙镇街道", num: 500 },
            { name: "五五新镇街道", num: 300 }
          ];
          var color = [
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249",
            "rgba(100,255,249"
          ];
          let userListdata = [];
          let RoldDataList1 = [];
          let RoldDataList2 = [];
          let RoldDataList3 = [];
          let RoldDataList4 = [];
          let RoldDataList5 = [];
          let RoldDataList6 = [];
          let newuserListdata = [];
          let colorList = [];

          for (let index = 0; index < 20; index++) {
            // userListdata.push(`用户${index + 1}`);
            // console.log();
            let isTrue = parseInt(Math.random() * (100 - 1) + 1) % 2 == 0;
            userListdata.push(`用户${index + 1}(${isTrue ? "下线" : "在线"})`);
          }
          console.log(userListdata);
          userListdata.map((item2, index) => {
            const randomRed = Math.floor(Math.random() * 256);
            const randomGreen = Math.floor(Math.random() * 256);
            const randomBlue = Math.floor(Math.random() * 256);

            colorList.push(`rgb(${randomRed}, ${randomGreen}, ${randomBlue})`);
            newuserListdata.push({ name: item2, icon: "circle" });
            RoldDataList2.push(
              Math.floor(Math.random() * (300 - 100 + 1) + 100)
            );
            RoldDataList1.push(Math.floor(Math.random() * (100 - 20 + 1) + 50));
            RoldDataList3.push(Math.floor(Math.random() * (20 - 10 + 1) + 10));
            RoldDataList5.push(
              Math.floor(Math.random() * (400 - 200 + 1) + 200)
            );
            RoldDataList4.push(
              Math.floor(Math.random() * (200 - 100 + 1) + 100)
            );
            // RoldDataList5.push(Math.floor(Math.random() * (50 - 10 + 1) + 10));
            RoldDataList6.push(Math.floor(Math.random() * (50 - 10 + 1) + 10));
          });
          // console.log(RoldDataList);
          let option = {
            color: ["#2E8CFF", "#FD9133", "#37D2D4", "#19CA88", "#858FF8"],
            dataZoom: [
              {
                type: "slider", //slider表示有滑动块的，
                show: true,
                width: 8,
                fillerColor: "rgb(16, 171, 198)",
                yAxisIndex: [0], //表示x轴折叠
                start: 1, //数据窗口范围的起始百分比,表示1%
                end: 25 //数据窗口范围的结束百分比,表示35%坐标
              },
              {
                type: "inside", //
                yAxisIndex: [0], //表示y轴折叠
                start: 1,
                end: 35
              }
            ],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow"
              }
            },
            legend: {
              type: "scroll",

              // orient: "vertical",
              x: "center", //可设定图例在左、右、居中
              y: "top", //可设定图例在上、下、居中
              padding: [5, 0, 0, 0], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
              // data: ["直接访问", "微信", "百度", "其他文章", "网页"]
              textStyle: {
                color: "#fff",
                fontSize: 20
              }
            },

            grid: {
              left: "0%",
              right: "4%",
              bottom: "3%",
              top: "10%",
              containLabel: true
            },
            xAxis: [
              {
                type: "value",
                axisLine: {
                  lineStyle: {
                    color: "#fff"
                  }
                }
              }
            ],
            yAxis: [
              {
                type: "category",
                data: userListdata,

                axisLine: {
                  lineStyle: {
                    color: e => {
                      // console.log(1111);
                      if (e.search("在线") == -1) {
                        return "red";
                      } else {
                        return "green";
                      }
                      // if(e)
                    }
                  }
                },
                axisLabel: {
                  fontSize: 16,
                  fontWeight: 700
                }
              }
            ],
            series: [
              {
                name: "周完成面积",
                data: RoldDataList1,
                type: "bar"
              },
              {
                name: "月完成面积",
                data: RoldDataList2,
                type: "bar"
              },
              {
                name: "日完成面积",
                data: RoldDataList3,
                type: "bar"
              },
              {
                name: "周完成作物",
                data: RoldDataList4,
                type: "bar"
              },
              {
                name: "月完成作物",
                data: RoldDataList5,
                type: "bar"
              },
              {
                name: "日完成作物",
                data: RoldDataList6,
                type: "bar"
              }
            ]
          };
          baseChart.on("click", function(params) {
            alert(`切换详细${params.name}信息`);
          });
          baseChart.setOption(option);
          setInterval(function() {
            baseChart.clear();
            baseChart.setOption(option);
          }, 40000);
        },
        baseInfo2: function() {
          console.log("baseInfo2");
          var baseChart2 = echarts.init(document.getElementById("waiye2"));
          let userListdata = [];
          let RoldDataList = [];
          let newuserListdata = [];
          let colorList = [];
          for (let index = 0; index < 20; index++) {
            userListdata.push(`用户${index + 1}`);
          }
          // console.log(userListdata);
          userListdata.map((item2, index) => {
            const randomRed = Math.floor(Math.random() * 256);
            const randomGreen = Math.floor(Math.random() * 256);
            const randomBlue = Math.floor(Math.random() * 256);

            colorList.push(`rgb(${randomRed}, ${randomGreen}, ${randomBlue})`);
            newuserListdata.push({ name: item2, icon: "circle" });
            let placeDataList = [];
            for (let index2 = 0; index2 < 7; index2++) {
              if (index2 == 0) {
                placeDataList.push(
                  Math.floor(Math.random() * (200 - 20 + 1) + 20)
                );
              } else {
                placeDataList.push(
                  placeDataList[index2 - 1] +
                    Math.floor(Math.random() * (200 - 20 + 1) + 20)
                );
              }
            }
            console.log(placeDataList);
            RoldDataList.push({
              name: item2,
              data: placeDataList,
              type: "line",
              smooth: true
            });
          });
          console.log(RoldDataList);
          var option = {
            color: colorList,
            legend: {
              type: "scroll",
              data: newuserListdata,
              selectedMode: true,
              // orient: "vertical",
              x: "center", //可设定图例在左、右、居中
              y: "top", //可设定图例在上、下、居中
              padding: [0, 0, 0, 0], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
              // data: ["直接访问", "微信", "百度", "其他文章", "网页"]
              textStyle: {
                color: "#fff",
                fontSize: 20
              }
            },
            dataZoom: [
              {
                type: "slider", //slider表示有滑动块的，
                show: true,
                width: 8,
                fillerColor: "rgb(16, 171, 198)",
                yAxisIndex: [0], //表示x轴折叠
                start: 1, //数据窗口范围的起始百分比,表示1%
                end: 35 //数据窗口范围的结束百分比,表示35%坐标
              },
              {
                type: "inside", //
                yAxisIndex: [0], //表示y轴折叠
                start: 1,
                end: 35
              }
            ],
            xAxis: {
              type: "category",
              data: [
                "1月2日",
                "1月3日",
                "1月4日",
                "1月5日",
                "1月6日",
                "1月7日",
                "1月8日"
              ],
              axisLabel: {
                rotate: 40
              },
              axisLine: {
                lineStyle: {
                  color: "#fff"
                }
              }
            },
            // legend: {
            //   type: "scroll",

            //   // orient: "vertical",
            //   x: "center", //可设定图例在左、右、居中
            //   y: "top", //可设定图例在上、下、居中
            //   padding: [5, 0, 0, 0], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
            //   // data: ["直接访问", "微信", "百度", "其他文章", "网页"]
            //   textStyle: {
            //     color: "#fff",
            //     fontSize: 20
            //   }
            // },
            grid: {
              left: "1%",
              right: "1%",
              bottom: "1%",
              top: "10%",
              containLabel: true
            },
            yAxis: {
              type: "value",

              axisLine: {
                lineStyle: {
                  color: "#fff"
                }
              }
            },
            series: RoldDataList
          };

          baseChart2.setOption(option);
          baseChart2.on("click", function(params) {
            console.log(params);
            let option2 = baseChart2.getOption();
            console.log(option2.legend[0].data);
            option2.legend[0].data = [
              {
                name: params.seriesName,
                icon: "circle"
              }
            ];
            console.log(params.seriesName);
            option2.series[0].data = [10, 30, 10, 5, 9, 12, 15];
            option2.series[1].data = [];
            option2.series[2].data = [];
            option2.xAxis[0].data = [
              params.name + "12时",
              params.name + "13时",
              params.name + "14时",
              params.name + "15时",
              params.name + "16时",
              params.name + "17时",
              params.name + "18时"
            ];
            baseChart2.setOption(option2);
          });
          baseChart2.on("legendselectchanged", function(params) {
            console.log(params);
            let option2 = baseChart2.getOption();
            console.log(option2);
            console.log(params.selected);
            let mydata = params.selected;
            const keys = Object.keys(mydata);
            keys.forEach(key => {
              console.log(`${key}: ${mydata[key]}`);
              if (key == params.name) {
                mydata[key] = true;
              } else {
                mydata[key] = false;
              }
            });
            console.log(mydata);
            option2.legend[0].selected = mydata;

            // var option3 = baseChart2.getOption();

            baseChart2.setOption(option2);
          });
          // setInterval(function() {
          //   baseChart2.clear();
          //   baseChart2.setOption(option);
          // }, 40000);
        },
        // 问题反馈类型占比
        questionFn: function() {
          var numArr = [
            { name: "天山区", value: 2000 },
            { name: "沙依巴克区", value: 3000 },
            { name: "水磨沟区", value: 400 },
            { name: "头屯河区", value: 500 },
            { name: "达坂城区", value: 300 }
          ];
          // for(var i = 0; i < data.list.length; i++) {
          //     numArr.push({name: data.list[i].name,value: data.list[i].num})
          // }
          var datas = numArr;
          var questionChart = echarts.init(
            document.getElementById("questionId")
          );
          var option = {
            title: {
              left: "center"
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            color: ["#2E8CFF", "#FD9133", "#37D2D4", "#19CA88", "#858FF8"],
            legend: {
              itemWidth: 11, // 标志图形的长度
              itemHeight: 11, // 标志图形的宽度
              orient: "vertical",
              // left: 'right',
              top: "15%",
              x: "50%",
              data: datas,
              textStyle: {
                //图例文字的样式
                color: "#fff",
                fontSize: 8
              }
            },
            series: [
              {
                name: "问题反馈",
                type: "pie",
                radius: "75%",
                center: ["20%", "50%"],
                animationDuration: 2500,
                data: datas,
                label: {
                  normal: {
                    position: "inner",
                    show: false
                  }
                }
              }
            ]
          };
          questionChart.setOption(option);
          setInterval(function() {
            questionChart.clear();
            questionChart.setOption(option);
          }, 8000);
        },
        // 党务公开
        publicityFn33: function() {
          t.$axios({
            method: "get",
            url:
              "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisInsureByScene" // 接口地址
          })
            .then(response => {
              let newArr = [];
              let newArr2 = [];
              let palanarr = [];
              let dataarr = [];
              let colorList = [
                "#4ad2ff",
                "#F7E16C",
                "#38EB70",
                "#FD9132",
                "#9ebc19",
                "#007175"
              ];
              let datalist = response.data.dataList;
              response.data.dataList.map(item => {
                newArr.push(item.scene_id);
                newArr2.push(item.scene_id + "号区域");
                palanarr.push(item.crop);
              });

              // console.log(Array.from(new Set(newArr)));
              let xarr = Array.from(new Set(newArr));
              let xarr2 = Array.from(new Set(newArr2));
              let newcrop = Array.from(new Set(palanarr));
              console.log(xarr);
              console.log(xarr2);
              console.log(newcrop);
              let newservearr = [];
              newcrop.map((item, index) => {
                let data = [];
                console.log(item);
                xarr.map(item2 => {
                  console.log(item2);
                  let fltdata = datalist.filter(
                    word => word.scene_id == item2 && word.crop == item
                  );
                  if (fltdata.length == 0) {
                    data.push(0);
                  } else {
                    data.push(fltdata[0].cbmj);
                  }
                  // console.log();
                });
                console.log(data);
                newservearr.push({
                  name: item,
                  type: "bar",
                  itemStyle: {
                    normal: {
                      color: colorList[index]
                    }
                  },
                  emphasis: {
                    focus: "series"
                  },

                  data: data
                });
              });
              console.log(newservearr);
              var dataArr = [
                { name: "农业开发区", value: 2000 },
                { name: "小拐乡", value: 3000 },
                { name: "胜利路街道", value: 400 },
                { name: "金龙镇街道", value: 500 },
                { name: "五五新镇街道", value: 300 }
              ];
              // for(var i = 0; i < res.list.length; i++) {
              //     dataArr.push({name: res.list[i].name, value: res.list[i].num})
              // }

              var publicitChart = echarts.init(
                document.getElementById("waiye")
              );
              var data = dataArr;
              let option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow"
                  }
                },
                legend: {
                  textStyle: {
                    //图例文字的样式
                    color: "#ccc",
                    fontSize: 16
                  }
                },
                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                xAxis: [
                  {
                    type: "value",
                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    }
                  }
                ],
                yAxis: [
                  {
                    type: "category",
                    data: xarr2,
                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    },
                    axisLabel: {
                      fontSize: 19,
                      fontWeight: 700
                    }
                  }
                ],
                series: newservearr
              };
              publicitChart.setOption(option);
              setInterval(function() {
                publicitChart.clear();
                publicitChart.setOption(option);
              }, 6000);
              // 成功的返回
            })
            .catch(error => console.log(error, "error"));
        },
        publicityFn: function() {
          t.$axios({
            method: "get",
            url:
              "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisInsureByScene" // 接口地址
          })
            .then(response => {
              console.log(212121);
              console.log(response.data.dataList);
              let datalist = response.data.dataList;
              let newArr = [];
              let newArr2 = [];
              let palanarr = [];
              response.data.dataList.map(item => {
                newArr.push(item.scene_id);
                newArr2.push(item.scene_id + "号区域");
                palanarr.push(item.crop);
              });

              // console.log(Array.from(new Set(newArr)));
              let xarr = Array.from(new Set(newArr));
              let xarr2 = Array.from(new Set(newArr2));
              let newcrop = Array.from(new Set(palanarr));
              let datalist2 = [];
              let legendList = [];
              newcrop.map(item => {
                let filterList = datalist.filter(el => el.crop == item);
                console.log(filterList);
                // console.log();
                legendList.push({ name: item });
                datalist2.push(filterList.reduce((c, R) => c + R.cbmj, 0));
              });
              console.log(datalist2);

              // for(var i = 0; i < res.list.length; i++) {
              //     dataArr.push({name: res.list[i].name, value: res.list[i].num})
              // }

              var publicitChart = echarts.init(
                document.getElementById("waiye")
              );
              // var data = dataArr;
              let option = {
                color: [
                  "#2E8CFF",
                  "#38EB70",

                  "#0EFCFF",
                  "#858FF8",
                  "#FD9133",
                  "#F7E270"
                ],
                dataZoom: [
                  {
                    type: "slider", //slider表示有滑动块的，
                    show: true,
                    width: 8,
                    fillerColor: "rgb(16, 171, 198)",
                    yAxisIndex: [0], //表示x轴折叠
                    start: 1, //数据窗口范围的起始百分比,表示1%
                    end: 35 //数据窗口范围的结束百分比,表示35%坐标
                  },
                  {
                    type: "inside", //
                    yAxisIndex: [0], //表示y轴折叠
                    start: 1,
                    end: 35
                  }
                ],
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow"
                  }
                },

                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                xAxis: [
                  {
                    type: "value",
                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    }
                  }
                ],
                yAxis: [
                  {
                    type: "category",
                    data: newcrop,
                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    },
                    axisLabel: {
                      fontSize: 14,
                      fontWeight: 700
                    }
                  }
                ],
                series: [
                  {
                    data: datalist2,
                    type: "bar",
                    barWidth: 10
                  }
                ]
              };
              publicitChart.setOption(option);
              setInterval(function() {
                publicitChart.clear();
                publicitChart.setOption(option);
              }, 6000);
              // 成功的返回
            })
            .catch(error => console.log(error, "error"));
        },
        // 三务公开数量
        threeTasksFn22: function() {
          let names = "666666";
          if (6 - names.length > 0) {
            for (g = 0; g < 6 - names.length; g++) {
              $(".main_top_middle_num_list" + (6 - g)).text("0");
            }
          }
          for (var j = 0; j < names.length; j++) {
            $(".main_top_middle_num_list" + (names.length - j)).text(
              names.substr(j, 1)
            );
          }
          var dataArr = [
            { name: "玉米", value: 300 },
            { name: "小麦", value: 500 },
            { name: "土豆", value: 400 },
            { name: "烟草", value: 350 },
            { name: "果树", value: 363 },
            { name: "其他", value: 800 }
          ];
          for (var i = 1; i < dataArr.length; i++) {
            $(".main_top_left_c_l_n" + i)
              .addClass("counter-value")
              .text(dataArr[i].value);
          }
          var threeTasksChart = echarts.init(
            document.getElementById("threeTasksId")
          );
          var data = dataArr;
          var option = {
            color: [
              "#38EB70",
              "#2E8CFF",
              "#0EFCFF",
              "#858FF8",
              "#FD9133",
              "#F7E270"
            ],
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              itemWidth: 15, // 标志图形的长度
              itemHeight: 15, // 标志图形的宽度
              orient: "vertical",
              // left: 'right',
              top: "10%",
              bottom: "50%",
              x: "50%",
              textStyle: {
                color: "#fff",
                fontSize: 8
              },
              data: data
            },
            series: {
              name: "作物田块数量",
              type: "pie",
              animationDuration: 1500,
              radius: ["70%", "90%"],
              center: ["25%", "50%"],
              roseType: "radius",
              label: {
                normal: {
                  position: "inner",
                  show: false
                }
              },
              data: data
            }
          };
          threeTasksChart.setOption(option);
          setInterval(function() {
            threeTasksChart.clear();
            threeTasksChart.setOption(option);
          }, 4000);
        },
        threeTasksFn: function() {
          t.$axios({
            method: "get",
            url:
              "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisInsureByCrop" // 接口地址
          })
            .then(response => {
              console.log(1212);
              // console.log(response.data.dataList);
              let colorList = [
                "#4ad2ff",
                "#F7E16C",
                "#38EB70",
                "#FD9132",
                "#9ebc19",
                "#007175"
              ];
              let newServe = [];
              response.data.dataList.map((item, index) => {
                newServe.push({
                  name: item.crop,
                  type: "bar",
                  emphasis: {
                    focus: "series"
                  },
                  itemStyle: {
                    normal: {
                      color: colorList[index]
                    }
                  },

                  data: [item.cbmj]
                });
              });
              var threeTasksChart = echarts.init(
                document.getElementById("threeTasksId")
              );
              let option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "shadow"
                  }
                },
                legend: {
                  textStyle: {
                    //图例文字的样式
                    color: "#ccc",
                    fontSize: 16
                  }
                },
                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                xAxis: [
                  {
                    type: "log",
                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    }
                  }
                ],
                yAxis: [
                  {
                    type: "category",

                    axisLine: {
                      lineStyle: {
                        color: "#fff"
                      }
                    }
                  }
                ],
                series: newServe
              };
              threeTasksChart.setOption(option);
              setInterval(function() {
                threeTasksChart.clear();
                threeTasksChart.setOption(option);
              }, 4000);
              // 成功的返回
            })
            .catch(error => console.log(error, "error"));
        },
        // 各部门苏木镇嘎查村公开占比
        departmentFn: function() {
          var dataArr = [
            { name: "新增田块", value: 1500 },
            { name: "修改田块", value: 500 },
            { name: "上传照片", value: 4000 },
            { name: "更新信息", value: 300 },
            { name: "上传投保", value: 36 }
          ];
          // 中间滚动数据展示
          // for (var j = 0; j < dataArr.length; j++) {
          //   $(".main_list_title_num" + (j + 1))
          //     .addClass("counter-value")
          //     .text(dataArr[j].value);
          //   $(".main_list_title" + (j + 1)).text(dataArr[j].name);
          // }
          var departmentChart = echarts.init(
            document.getElementById("departmentId")
          );
          var data = dataArr;
          var option = {
            color: ["#FD9133", "#47F6A2", "#37D2D4", "#3493FF"],
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              itemWidth: 15, // 标志图形的长度
              itemHeight: 15, // 标志图形的宽度
              orient: "vertical",
              // left: 'right',
              top: "30%",
              bottom: "50%",
              x: "5%",
              textStyle: {
                color: "#fff",
                fontSize: 8
              },
              data: data
            },
            series: [
              {
                name: "XXXX公开占比",
                type: "pie",
                radius: ["50%", "70%"],
                center: ["78%", "52%"],
                labelLine: {
                  normal: {
                    length: 12,
                    lineStyle: {
                      type: "solid",
                      color: "#0EFCFF"
                    }
                  }
                },
                label: {
                  normal: {
                    formatter: params => {
                      return params.name;
                    },
                    borderWidth: 0,
                    borderRadius: 4,
                    padding: [0, 0],
                    height: 20,
                    fontSize: 8,
                    align: "center",
                    color: "#0EFCFF"
                  }
                },
                data: data
              },
              {
                color: "#0EFCFF",
                type: "pie",
                radius: ["55", "56"],
                center: ["78%", "52%"],
                data: [100],
                label: {
                  show: false
                }
              },
              {
                type: "pie",
                radius: ["25", "26"],
                center: ["78%", "52%"],
                data: [100],
                label: {
                  show: false
                }
              }
            ]
          };
          departmentChart.setOption(option);
          setInterval(function() {
            departmentChart.clear();
            departmentChart.setOption(option);
          }, 12000);
        },
        // 办事指南
        guideFn: function() {
          $(".main_bottom_t_l_main").jCarouselLite({
            vertical: true,
            hoverPause: true,
            visible: 4,
            auto: 1000,
            speed: 500
          });
        },
        // 政策解读
        policyFn: function() {
          $(".main_bottom_t_l_main2").jCarouselLite({
            vertical: true,
            hoverPause: true,
            visible: 4,
            auto: 1000,
            speed: 500
          });
        },
        // 主要关注内容区域占比
        coverageFn: function() {
          var resArr = [
            { name: "新增田块", value: 300 },
            { name: "新增投保", value: 500 },
            { name: "更新田块", value: 400 },
            { name: "更新信息", value: 350 },
            { name: "删除田块", value: 363 },
            { name: "上传投保", value: 800 }
          ];
          var indicatorArr = [];
          var numArr = [];
          for (var i = 0; i < resArr.length; i++) {
            indicatorArr.push({ name: resArr[i].name, max: 900 });
            numArr.push(resArr[i].value);
          }
          var data = [
            {
              value: numArr
            }
          ];
          var coverageChart = echarts.init(
            document.getElementById("coverageId")
          );
          var option = {
            legend: {
              show: true,
              icon: "circle",
              bottom: 30,
              center: 0,
              itemWidth: 14,
              itemHeight: 14,
              itemGap: 21,
              orient: "horizontal",
              data: ["a", "b"],
              textStyle: {
                fontSize: "70%",
                color: "#0EFCFF"
              }
            },

            radar: {
              // shape: 'circle',
              radius: "70%",
              triggerEvent: true,
              // type: 'default',
              name: {
                textStyle: {
                  color: "#39DCF4",
                  fontSize: "10",
                  // borderRadius: 3,
                  padding: [10, 10]
                }
              },
              nameGap: "2",
              indicator: indicatorArr,
              splitArea: {
                areaStyle: {
                  color: "rgba(255,255,255,0)"
                }
              },
              axisLine: {
                //指向外圈文本的分隔线样式
                lineStyle: {
                  color: "rgba(255,255,255,.2)"
                }
              },
              splitLine: {
                lineStyle: {
                  width: 1,
                  color: "rgba(255,255,255,.2)"
                }
              }
            },
            series: [
              {
                name: "XXX区域占比",
                type: "radar",
                animationDuration: 2000,
                areaStyle: {
                  normal: {
                    color: {
                      type: "linear",
                      opacity: 1,
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      color: "#2EEFAD"
                    }
                  }
                },
                symbolSize: 0,
                lineStyle: {
                  normal: {
                    // color: 'rgba(252,211,3, 1)',
                    width: 0
                  }
                },
                data: data
              }
            ]
          };
          coverageChart.setOption(option);
          setInterval(function() {
            coverageChart.clear();
            coverageChart.setOption(option);
          }, 10000);
        },
        coverageFn2: function() {
          var dataArr = [
            { name: "已下线", value: 2000 },
            { name: "上线中", value: 3000 }
          ];
          // for(var i = 0; i < res.list.length; i++) {
          //     dataArr.push({name: res.list[i].name, value: res.list[i].num})
          // }

          var publicitChart = echarts.init(
            document.getElementById("coverageId2")
          );
          var data = dataArr;
          var option = {
            color: ["#38EB70", "#F7E16C", "#0EFCFF", "#FD9133", "#4D92F2"],
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              itemWidth: 12, // 标志图形的长度
              itemHeight: 12, // 标志图形的宽度
              orient: "vertical",
              // left: 'right',
              top: "5%",
              bottom: "50%",
              x: "80%",
              textStyle: {
                color: "#fff",
                fontSize: 8
              },
              data: data
            },
            series: [
              // 主要展示层的
              {
                radius: ["70%", "90%"],
                center: ["50%", "50%"],
                type: "pie",
                label: {
                  normal: {
                    position: "inner",
                    show: false
                  }
                },
                name: "XX公开数量",
                data: data
              },
              // 边框的设置
              {
                radius: ["50%", "55%"],
                center: ["50%", "50%"],
                type: "pie",
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: false
                  }
                },
                animation: false,
                tooltip: {
                  show: false
                },
                data: [
                  {
                    value: 1,
                    itemStyle: {
                      color: "rgba(250,250,250,0.3)"
                    }
                  }
                ]
              }
            ]
          };
          publicitChart.setOption(option);
          setInterval(function() {
            publicitChart.clear();
            publicitChart.setOption(option);
          }, 6000);
        },
        // 本年公开数量
        yearsNumFn: function() {
          var resArr = [
            { name: "测试11", value: 30 },
            { name: "测试22", value: 50 },
            { name: "测试33", value: 40 },
            { name: "测试44", value: 35 },
            { name: "测试55", value: 36 },
            { name: "测试66", value: 80 }
          ];
          var nameArr = [];
          var caiArr = [];
          var cunArr = [];
          var danArr = [];
          var junArr = [];
          var zhenArr = [];
          for (var i = 0; i < resArr.length; i++) {
            nameArr.push(resArr[i].name);
            caiArr.push(resArr[i].value);
            cunArr.push(resArr[i].value);
            danArr.push(resArr[i].value);
            junArr.push(resArr[i].value);
            zhenArr.push(resArr[i].value);
          }
          var yearsNumChart = echarts.init(
            document.getElementById("yearsNumId")
          );
          var spNum = 5,
            _max = 100;
          var y_data = nameArr.reverse();
          var _datamax = [
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100
            ],
            _data1 = caiArr.reverse(),
            _data2 = cunArr.reverse(),
            _data3 = danArr.reverse();
          _data4 = junArr.reverse();
          _data5 = zhenArr.reverse();
          var fomatter_fn = function(v) {
            return ((v.value / _max) * 100).toFixed(0);
          };
          var _label = {
            normal: {
              show: true,
              position: "inside",
              formatter: fomatter_fn,
              textStyle: {
                color: "#fff",
                fontSize: 8
              }
            }
          };
          var option = {
            grid: {
              containLabel: true,
              left: 0,
              top: 0,
              right: 0,
              bottom: 0
            },
            tooltip: {
              show: true,
              backgroundColor: "#fff",
              borderColor: "#ddd",
              borderWidth: 1,
              textStyle: {
                color: "#3c3c3c",
                fontSize: 16
              },
              extraCssText: "box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)"
            },
            xAxis: {
              splitNumber: spNum,
              interval: _max / spNum,
              max: _max,
              axisLabel: {
                show: false,
                formatter: function(v) {
                  var _v = ((v / _max) * 100).toFixed(0);
                  return _v == 0 ? _v : _v + "%";
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            yAxis: [
              {
                data: y_data,
                axisLabel: {
                  fontSize: 8,
                  color: "rgba(255,255,255,.7)"
                },
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                splitLine: {
                  show: false
                }
              },
              {
                show: false,
                data: y_data,
                axisLine: {
                  show: false
                }
              }
            ],
            series: [
              {
                type: "bar",
                name: "财务",
                stack: "2",
                label: _label,
                legendHoverLink: false,
                barWidth: 7,
                itemStyle: {
                  normal: {
                    color: "#FD9133"
                  },
                  emphasis: {
                    color: "#FD9133"
                  }
                },
                data: _data1
              },
              {
                type: "bar",
                name: "村务",
                stack: "2",
                legendHoverLink: false,
                barWidth: 20,
                label: _label,
                itemStyle: {
                  normal: {
                    color: "#2E8CFF"
                  },
                  emphasis: {
                    color: "#2E8CFF"
                  }
                },
                data: _data2
              },
              {
                type: "bar",
                stack: "2",
                name: "党务",
                legendHoverLink: false,
                barWidth: 20,
                label: _label,
                itemStyle: {
                  normal: {
                    color: "#37D2D4"
                  },
                  emphasis: {
                    color: "#37D2D4"
                  }
                },
                data: _data3
              },
              {
                type: "bar",
                stack: "2",
                name: "居务",
                legendHoverLink: false,
                barWidth: 20,
                label: _label,
                itemStyle: {
                  normal: {
                    color: "#19CA88"
                  },
                  emphasis: {
                    color: "#19CA88"
                  }
                },
                data: _data4
              },
              {
                type: "bar",
                stack: "2",
                name: "政务",
                legendHoverLink: false,
                barWidth: 20,
                label: _label,
                itemStyle: {
                  normal: {
                    color: "#0EFCFF"
                  },
                  emphasis: {
                    color: "#0EFCFF"
                  }
                },
                data: _data5
              }
            ]
          };
          yearsNumChart.setOption(option);
          setInterval(function() {
            yearsNumChart.clear();
            yearsNumChart.setOption(option);
          }, 120000);
        },
        // 关注内容区域占比
        contentFn: function() {
          var resArr = [
            { name: "测试11", value: 30 },
            { name: "测试22", value: 50 },
            { name: "测试55", value: 33 },
            { name: "测试66", value: 80 }
          ];
          var nameArr = [];
          var caiArr = [];
          var cunArr = [];
          var danArr = [];
          var junArr = [];
          var zhenArr = [];
          for (var i = 0; i < resArr.length; i++) {
            nameArr.push(resArr[i].name);
            caiArr.push(resArr[i].value);
            cunArr.push(resArr[i].value);
            danArr.push(resArr[i].value);
            junArr.push(resArr[i].value);
            zhenArr.push(resArr[i].value);
          }

          var contentChart = echarts.init(document.getElementById("contentId"));
          var option = {
            tooltip: {
              trigger: "axis"
            },
            legend: {
              x: "35%",
              y: "0%",
              data: ["财务", "村务", "党务", "居务", "政务"],
              textStyle: {
                color: "#fff",
                fontSize: 8
              },
              itemWidth: 10,
              itemHeight: 10
            },
            calculable: true,
            xAxis: [
              {
                type: "category",
                data: nameArr,
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    fontSize: 8,
                    color: "rgba(255,255,255,.7)"
                  }
                },
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                scale: true,
                name: "单位：%",
                nameTextStyle: {
                  color: "rgba(255,255,255,.7)",
                  fontSize: 8
                },
                max: 100,
                min: 0,
                boundaryGap: [0.2, 0.2],
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: "rgba(255,255,255,.8)",
                    fontSize: 8
                    // opacity: 0.1,
                  }
                },
                splitLine: {
                  //决定是否显示坐标中网格
                  show: true,
                  lineStyle: {
                    color: ["#fff"],
                    opacity: 0.2
                  }
                }
              },
              {
                type: "value",
                scale: true,
                show: false,
                // name: "销量额(万元)",
                nameTextStyle: {
                  color: "rgba(255,255,255,.2)"
                },
                max: 1,
                min: 0,
                boundaryGap: [0.2, 0.2],
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: "rgba(255,255,255,.2)"
                    // opacity: 0.1,
                  }
                },
                splitLine: {
                  //决定是否显示坐标中网格
                  show: true,
                  lineStyle: {
                    color: ["#fff"],
                    opacity: 0.2
                  }
                }
              }
            ],
            color: ["#0EFCFF", "#FD9133"],
            grid: {
              left: "5%",
              right: "1%",
              top: "25%",
              bottom: "15%"
              // containLabel: true
            },
            series: [
              {
                barWidth: "10%",
                name: "财务",
                type: "bar",
                data: caiArr
              },
              {
                animationDuration: 2500,
                barWidth: "20%",
                name: "村务",
                type: "bar",
                data: cunArr
              },
              {
                animationDuration: 2500,
                barWidth: "20%",
                name: "党务",
                type: "bar",
                data: danArr
              },
              {
                animationDuration: 2500,
                barWidth: "20%",
                name: "居务",
                type: "bar",
                data: junArr
              },
              {
                animationDuration: 2500,
                barWidth: "20%",
                name: "政务",
                type: "bar",
                data: zhenArr
              }
            ]
          };
          contentChart.setOption(option);
          setInterval(function() {
            contentChart.clear();
            contentChart.setOption(option);
          }, 90000);
        },
        // 巡察
        publicNumFn: function() {
          var resArr = [
            { name: "测试11", value: 300 },
            { name: "测试22", value: 500 },
            { name: "测试33", value: 400 },
            { name: "测试44", value: 350 },
            { name: "测试55", value: 363 },
            { name: "测试66", value: 800 }
          ];
          var xunArr = [];
          var jingArr = [];
          var dateArr = [];
          for (var i = 0; i < resArr.length; i++) {
            xunArr.push(resArr[i].value);
            jingArr.push(resArr[i].value);
            dateArr.push(resArr[i].name);
          }
          var publicNumChart = echarts.init(
            document.getElementById("publicNumId")
          );
          var option = {
            tooltip: {
              trigger: "axis"
            },
            legend: {
              x: "35%",
              y: "0%",
              data: ["巡察", "警示"],
              textStyle: {
                color: "#fff",
                fontSize: 8
              },
              itemWidth: 10,
              itemHeight: 10
            },
            calculable: true,
            xAxis: [
              {
                type: "category",
                data: dateArr,
                axisLabel: {
                  interval: 0,
                  textStyle: {
                    fontSize: 8,
                    color: "rgba(255,255,255,.7)"
                  }
                },
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                scale: true,
                name: "单位：%",
                nameTextStyle: {
                  color: "rgba(255,255,255,.7)",
                  fontSize: 8
                },
                max: 1000,
                min: 0,
                boundaryGap: [0.2, 0.2],
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: "rgba(255,255,255,.8)",
                    fontSize: 8
                    // opacity: 0.1,
                  }
                },
                splitLine: {
                  //决定是否显示坐标中网格
                  show: true,
                  lineStyle: {
                    color: ["#fff"],
                    opacity: 0.2
                  }
                }
              },
              {
                type: "value",
                scale: true,
                show: false,
                // name: "销量额(万元)",
                nameTextStyle: {
                  color: "rgba(255,255,255,.2)"
                },
                max: 1,
                min: 0,
                boundaryGap: [0.2, 0.2],
                axisTick: {
                  //y轴刻度线
                  show: false
                },
                axisLine: {
                  //y轴
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: "rgba(255,255,255,.2)"
                    // opacity: 0.1,
                  }
                },
                splitLine: {
                  //决定是否显示坐标中网格
                  show: true,
                  lineStyle: {
                    color: ["#fff"],
                    opacity: 0.2
                  }
                }
              }
            ],
            color: ["#2E8CFF", "#38EB70"],
            grid: {
              left: "5%",
              right: "1%",
              top: "25%",
              bottom: "15%"
              // containLabel: true
            },
            series: [
              {
                animationDuration: 2500,
                barWidth: "20%",
                name: "巡察",
                type: "bar",
                data: xunArr
              },
              {
                barWidth: "20%",
                name: "警示",
                type: "bar",
                data: jingArr
              }
            ],
            animationEasing: "cubicOut"
          };
          publicNumChart.setOption(option);
          setInterval(function() {
            publicNumChart.clear();
            publicNumChart.setOption(option);
          }, 60000);
        }
      };
      var start = new apiFn();
      start.Init();
    });
    const imageURL2 =
      "http://t0.tianditu.gov.cn/img_w/wmts?" +
      "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
      "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
      "&tk=0759d4c051f51a6fae7218ad639eb340";
    const imageURL1 =
      "http://t0.tianditu.gov.cn/vec_w/wmts?" +
      "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
      "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
      "&tk=0759d4c051f51a6fae7218ad639eb340";
    const imageURL3 =
      "http://t0.tianditu.gov.cn/cva_w/wmts?" +
      "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
      "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
      "&tk=0759d4c051f51a6fae7218ad639eb340";
    var tianditushilian = L.tileLayer(imageURL2, {
      attribution: "stamen"
    });
    var tianditushilian2 = L.tileLayer(imageURL1, {
      attribution: "stamen2"
    });
    var tianditushilian3 = L.tileLayer(imageURL3, {
      attribution: "stamen2"
    });

    var map1 = L.map("publicNumId", { layers: [normal.image] }).setView(
      [38, 114],
      12
    );

    // tianditushilian.addTo(map1);
    // tianditushilian3.addTo(map1);
    var map2 = L.map("mymap", { layers: [normal.Gaode] }).setView(
      [38, 114],
      12
    );
    this.showprintdata();

    // var layer1 = L.tileLayer(
    //   "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    // );
    // var layer2 = L.tileLayer(
    //   "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    // );
    // layer1.addTo(map1);
    // let t = this;
    map1.on("click", () => {
      let baseLayer = L.layerGroup([
        L.tileLayer(
          "http://t4.tianditu.gov.cn/img_c/wmts?layer=img&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk=0759d4c051f51a6fae7218ad639eb340",
          {
            maxZoom: 20,
            tileSize: 256,
            zoomOffset: 1
          }
        ),
        L.tileLayer(
          "http://t4.tianditu.gov.cn/cia_c/wmts?layer=cia&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk=0759d4c051f51a6fae7218ad639eb340",
          {
            maxZoom: 20,
            tileSize: 256,
            zoomOffset: 1
          }
        )
      ]);
      // console.log(12121);
      t.isSHowmap = true;
      setTimeout(() => {
        let map3 = L.map("mainmapBox", {
          layers: baseLayer,
          crs: L.CRS.EPSG4326
        }).setView([38, 114], 12);
        // tianditushilian.addTo(map3);
        t.map3 = map3;
        // tianditushilian2.addTo(map3);
      }, 500);
    });
    this.map = map2;
    this.map2 = map1;
    this.showNumTomap();
    map2.on("click", () => {
      let baseLayer = L.layerGroup([
        L.tileLayer(
          "http://t4.tianditu.gov.cn/vec_c/wmts?layer=vec&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk=48dd9495f4ad91f6973ec7c2ffca72c3",
          {
            maxZoom: 20,
            tileSize: 256,
            zoomOffset: 1
          }
        ),
        L.tileLayer(
          "http://t4.tianditu.gov.cn/cva_c/wmts?layer=cva&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk=48dd9495f4ad91f6973ec7c2ffca72c3",
          {
            maxZoom: 20,
            tileSize: 256,
            zoomOffset: 1
          }
        )
      ]);
      // console.log(12121);
      t.isSHowmap = true;
      setTimeout(() => {
        let map3 = L.map("mainmapBox", {
          layers: baseLayer,
          crs: L.CRS.EPSG4326
        }).setView([38, 114], 12);

        t.map3 = map3;
      }, 500);
      setTimeout(() => {
        t.showprintdata2();
      }, 1000);
    });
    // layer2.addTo(map2);
  },
  methods: {
    colorMpa() {
      this.map3.remove();
      this.isSHowmap = false;
    },
    getRoundNum() {
      return parseInt(Math.random() * (100 - 50 + 1) + 50, 10);
    },
    showNumTomap() {
      this.map2.flyTo([45.591398, 84.861137]);
      var myIcon = L.divIcon({
        html: "1444",
        className: "my-div-icon",
        iconSize: 20
      });
      // 你可以在 .my-div-icon CSS 中设置样式

      L.marker([45.651398, 84.861137], { icon: myIcon }).addTo(this.map2);
      var myIcon2 = L.divIcon({
        html: "1202",
        className: "my-div-icon",
        iconSize: 20
      });
      // 你可以在 .my-div-icon CSS 中设置样式

      L.marker([45.501398, 84.861137], { icon: myIcon2 }).addTo(this.map2);
    },
    showprintdata2() {
      this.$axios({
        method: "get",
        url:
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisTrack&thisid=11" // 接口地址
      })
        .then(response => {
          console.log(response.data.dataList);
          let printlist = [];
          response.data.dataList.map(item => {
            // console.log(item.gps.split(";"));
            let testarr = [];
            item.gps.split(";").map(item2 => {
              // console.log();
              testarr.push(item2.split(" ").reverse());
              var greenIcon = L.icon({
                iconUrl: mypng,

                iconSize: [35, 35] // size of the icon
              });
              L.marker(
                [Number(item2.split(" ")[1]), Number(item2.split(" ")[0])],
                {
                  icon: greenIcon
                }
              ).addTo(this.map3);
            });
            printlist.push(testarr);
          });
          console.log(printlist);
          // let printlist = [];
          // console.log(response.data.dataList);
          // response.data.dataList.map(item => {
          //   printlist.push([item.lat, item.lon]);
          // });

          var polyline = L.polyline(printlist, {
            color: "red",
            opacity: 0
          }).addTo(this.map3);
          var decorator = L.polylineDecorator(polyline, {
            patterns: [
              // defines a pattern of 10px-wide dashes, repeated every 20px on the line
              {
                offset: 0,
                repeat: 100,
                symbol: L.Symbol.dash({ pixelSize: 10 })
              }
            ]
          }).addTo(this.map3);
          // zoom the map to the polyline
          this.map3.fitBounds(polyline.getBounds());
          // 成功的返回
        })
        .catch(error => console.log(error, "error"));
    },
    showprintdata() {
      this.$axios({
        method: "get",
        url:
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisTrack&thisid=11" // 接口地址
      })
        .then(response => {
          console.log(response.data.dataList);
          let printlist = [];
          response.data.dataList.map(item => {
            // console.log(item.gps.split(";"));
            let testarr = [];
            item.gps.split(";").map(item2 => {
              // console.log();
              testarr.push(item2.split(" ").reverse());
              var greenIcon = L.icon({
                iconUrl: mypng,

                iconSize: [35, 35] // size of the icon
              });
              L.marker(item2.split(" ").reverse(), { icon: greenIcon }).addTo(
                this.map
              );
            });
            printlist.push(testarr);
          });
          console.log(printlist);
          // let printlist = [];
          // console.log(response.data.dataList);
          // response.data.dataList.map(item => {
          //   printlist.push([item.lat, item.lon]);
          // });

          var polyline = L.polyline(printlist, {
            color: "red",
            opacity: 0
          }).addTo(this.map);
          var decorator = L.polylineDecorator(polyline, {
            patterns: [
              // defines a pattern of 10px-wide dashes, repeated every 20px on the line
              {
                offset: 0,
                repeat: 100,
                symbol: L.Symbol.dash({ pixelSize: 10 })
              }
            ]
          }).addTo(this.map);
          // zoom the map to the polyline
          this.map.fitBounds(polyline.getBounds());
          // 成功的返回
        })
        .catch(error => console.log(error, "error"));
    },
    getphotonum() {
      this.$axios({
        method: "get",
        url:
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisPhoto&userId=11&adcode=73&places=384342" // 接口地址
      })
        .then(response => {
          console.log(response.data.dataList);
          // this.tblist = response.data.dataList;
          this.getphotoNum = response.data.dataList.length;
          // 成功的返回
        })
        .catch(error => console.log(error, "error"));
    },
    getnewTime(data) {
      return moment(data).format("YYYY-MM-DD");
    },
    gettblist() {
      this.$axios({
        method: "get",
        url:
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisInsureBytime&starttime=2023-04-26%2016:54:15&endtime=2024-04-26%2016:54:15" // 接口地址
      })
        .then(response => {
          console.log(121221);

          this.tblist = response.data.dataList.sort((a, b) => {
            return b.create_time - a.create_time;
          });
          // 成功的返回
        })
        .catch(error => console.log(error, "error"));
    },
    getmjdata() {
      this.$axios({
        method: "get",
        url:
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getGisInsure&adcode=8&places=32" // 接口地址
      })
        .then(response => {
          console.log(response.data.dataList[0].cbmj, "success");
          this.mjdata = response.data.dataList[0].tbxz
            .padStart(5, "0")
            .split("");
          this.tbtk = response.data.dataList[0].bdzzdd
            .padStart(5, "0")
            .split("");
          console.log(this.mjdata);
          // 成功的返回
        })
        .catch(error => console.log(error, "error"));
    }
  }
};
</script>
<style>
/* #publicNumId {
  background-color: red;
  overflow: hidden;
} */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.mymapBox {
  height: 80%;
  width: 95%;
  margin: auto;
  margin-top: 60px;
  /* background-color: red; */
  overflow: hidden;
  /* z-index: 999; */
}
.mymapBox2 {
  height: 80%;
  width: 95%;
  margin: auto;
  margin-top: 50px;
  /* background-color: red; */
  overflow: hidden;
  /* background-color: red; */
  /* overflow: hidden; */
  /* z-index: 999; */
}
#showmap {
  position: absolute;
  top: 0;
  z-index: 999;
  background-color: royalblue;
}
/* #mainmapBox {
  height: 80%;
  width: 100vw;
} */
.bigMapdata {
  height: 80vh;
  width: 80vw;
  background-color: #1d2b56;
  position: absolute;
  top: 10vh;
  left: 10vw;
  z-index: 9999;
  border: 10px solid #10fcff;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
}
.maincloseBox {
  height: 50px;
  width: 50px;
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}
.maincloseBox img {
  width: 80%;
  height: 80%;
}
.main_top_left_top_con {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.main_top_left_top_con .itemBox {
  width: 30%;
  height: 30%;
  background-color: red;
}
.my21box {
  width: 50%;
  height: 150px;
  margin-top: 20px;
  /* background-color: #42b983; */
}
.textbox {
  display: flex;
  justify-content: space-between;
}
.myhashbox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  /* background-color: #42b983; */
}
.isOnline {
  width: 25%;
  height: 20%;
  /* background-color: red; */
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  color: #0efcff;
  font-size: 14px;
  padding: 0 5px;
}
.iconbox {
  width: 30px;
  height: 30px;
  /* background-color: aliceblue; */
  border-radius: 50%;
  margin-left: 5px;
}
.iconbox2 {
  width: 20px;
  height: 20px;
  background-color: #59ff2e;
  /* border-radius: 50%; */
  margin-right: 5px;
}
.iconbox3 {
  width: 20px;
  height: 20px;
  background-color: #ff332e;
  /* border-radius: 50%; */
  margin-right: 5px;
}
.leng {
  height: 30px;
  width: 100%;
  display: flex;
}
.main_bottom_t_l_main {
  overflow: auto !important;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}
.main_bottom_t_l_main::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}
.main_bottom_b_middle1 {
  height: 170% !important;
  /* background-color: #ff332e; */
  position: relative;
  top: -70%;
}
.main_bottom_b_middle2 {
  height: 170% !important;
  /* background-color: #ff332e; */
  position: relative;
  top: -70%;
}
.my-div-icon {
  color: red;
  font-size: 30px;
}
</style>
